import React, { FC } from "react";
import ProjectButtons from "../components/ProjectButtons";
import { Project } from "@brg/api";
import {FlexBox} from "@brg/ui";
import {PrintProject} from "../../../components/PrintProject/PrintProject";
type PropsT = {
    project: Project;
    isModer?: boolean;
    isPresentation?: boolean;
    isOutsideTextPosition?: boolean;
  };

export const PsPresentationBtns:FC<PropsT> = ({ project, isModer, isPresentation, isOutsideTextPosition }) => {

    const printButton = <>{process.env.REACT_APP_API_CONNECTION_MODE === 'develop' && project && <FlexBox offsetTop={isPresentation ? 48 : 16} offsetTopMobile={24} width={'100%'} justify={isPresentation ? 'flex-start' : 'flex-end'}>
        <PrintProject isPresentation={isPresentation} isOutsideTextPosition={isOutsideTextPosition} project={project}/>
    </FlexBox>}</>

    return (
            <FlexBox className="PsPresentationBtns-wrapper" directionMobile={'column'}>
                <ProjectButtons project={project} dropdownVerticalPos={"top"} orientation='horizontal' dropdownPos={'right'} isBottomTooltip={true} isPresentation={isPresentation} isPresentationTooltip isOutsideTextPosition={isOutsideTextPosition} />
                {/*{printButton}*/}
            </FlexBox>
    )
}import React, { FC } from "react";
import ProjectButtons from "../components/ProjectButtons";
import { Project } from "@brg/api";
import {FlexBox} from "@brg/ui";
import {PrintProject} from "../../../components/PrintProject/PrintProject";
type PropsT = {
    project: Project;
    isModer?: boolean;
    isPresentation?: boolean;
    isOutsideTextPosition?: boolean;
  };

export const PsPresentationBtns:FC<PropsT> = ({ project, isModer, isPresentation, isOutsideTextPosition }) => {

    const printButton = <>{process.env.REACT_APP_API_CONNECTION_MODE === 'develop' && project && <FlexBox offsetTop={isPresentation ? 48 : 16} offsetTopMobile={24} width={'100%'} justify={isPresentation ? 'flex-start' : 'flex-end'}>
        <PrintProject isPresentation={isPresentation} isOutsideTextPosition={isOutsideTextPosition} project={project}/>
    </FlexBox>}</>

    return (
            <FlexBox className="PsPresentationBtns-wrapper" directionMobile={'column'}>
                <ProjectButtons project={project} dropdownVerticalPos={"top"} orientation='horizontal' dropdownPos={'right'} isBottomTooltip={true} isPresentation={isPresentation} isPresentationTooltip isOutsideTextPosition={isOutsideTextPosition} />
                {/*{printButton}*/}
            </FlexBox>
    )
}